import { render, staticRenderFns } from "./MaterialProjectAdd.vue?vue&type=template&id=00ed8fe0&scoped=true&"
import script from "./js/material_project_add.js?vue&type=script&lang=js&"
export * from "./js/material_project_add.js?vue&type=script&lang=js&"
import style0 from "./MaterialProjectAdd.vue?vue&type=style&index=0&id=00ed8fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ed8fe0",
  null
  
)

export default component.exports